export const environment = {
  production: true,
  connection: {
    name: 'LH Horitschon Softline Test',
    host: 'https://softline-test.horitschon.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
